/*
 * https://www.algolia.com/doc/api-reference/widgets/infinite-hits/js/
 */
import { infiniteHits } from "instantsearch.js/es/widgets";
import { ttecSolutionsHitTpl } from './tpl-ttecSolutionsHitTpl';

export const ttecSolutionsSearchResults = infiniteHits({
  container: "[data-ttecsolutions-results]",
  escapeHTML: true,
  cssClasses: {
    list: [
      'xs:grid xs:grid-cols-12 xs:gap-x-6 xs:gap-y-15'
    ],
    item: [
      'xs:col-span-4 md:col-span-3 mb-4 xs:mb-0'
    ]
  },
  templates: {
    item: ttecSolutionsHitTpl,
    empty: ``
  },
})